import {
  PaletteColor,
  PaletteOptions,
  SimplePaletteColorOptions,
} from "@mui/material";
import {
  red,
  grey,
  indigo,
  pink,
  green,
  yellow,
  amber,
  blue,
  blueGrey,
} from "@mui/material/colors";

declare module "@mui/material/styles" {
  interface Palette {
    textColor: PaletteColor;
    lightStatic: PaletteColor;
    darkStatic: PaletteColor;
  }
  interface PaletteOptions {
    textColor: SimplePaletteColorOptions;
    lightStatic: SimplePaletteColorOptions;
    darkStatic: SimplePaletteColorOptions;
  }
}

export const lightModePalette: PaletteOptions = {
  primary: {
    main: blue[500],
    light: blue[50],
    dark: blue[600],
    contrastText: indigo[800],
  },
  secondary: {
    main: "#D99036",
    light: "#FFF3E0",
    dark: "#C58331",
  },
  info: {
    main: blueGrey[100],
    light: blueGrey[50],
    dark: blueGrey[400],
  },
  success: {
    main: green[500],
    light: green[50],
    dark: green[900],
  },
  warning: {
    main: yellow[700],
    dark: amber[600],
    light: amber[100],
  },
  error: {
    main: red[600],
    light: red[50],
    dark: red[800],
  },

  textColor: {
    main: grey[800],
    light: grey[500],
    dark: "#262626",
  },

  background: {
    paper: "#F9FAFB",
    default: "#ffffff",
  },
  lightStatic: {
    main: blue[50],
    light: yellow[900],
  },
  darkStatic: {
    main: grey[900],
    light: grey[800],
  },
};

export const darkModePalette: PaletteOptions = {
  primary: {
    main: blue[500],
    light: "#0D1117",
    dark: indigo[800],
    contrastText: indigo[800],
  },
  secondary: {
    main: "#D99036",
    light: "#FFF3E0",
    dark: "#C58331",
  },
  success: {
    main: green[500],
    light: grey[700],
    dark: green[900],
  },
  warning: {
    main: yellow[700],
    dark: amber[600],
    light: amber[100],
  },
  error: {
    main: red[600],
    light: red[50],
    dark: red[800],
  },
  info: {
    main: blueGrey[400],
    light: "#ECEFF11A",
  },

  textColor: {
    main: grey[800],
    light: grey[400],
    dark: grey[100],
  },

  background: {
    paper: grey[900],
    default: grey[800],
  },
  lightStatic: {
    main: grey[100],
  },
  darkStatic: {
    main: grey[900],
    light: grey[800],
  },
};

// boxShadow: `0px 4px 15px 0px ${alpha(
//   theme.palette.textColor.main,
//   0.1
// )}`,
